export { getAppointmentId } from './getAppointmentId';
export {
  getAllPaperworkSteps,
  getPaperworkFormSteps,
} from './getPaperworkRoutes';
export { checkIsPaperworkRoute } from './checkIsPaperworkRoute';



// WEBPACK FOOTER //
// ./src/utils/paperwork/index.js